import React, { FC, useCallback, useEffect, useState } from 'react';

import * as S from './styles';
import { Toggle, Container } from './styles';

export interface IButtonChooserProps {
  leftTitle: string;
  rightTitle: string;
  centerTitle: string;
  onChange?: (selectedTitle: string) => void;
  defaultValue?: string;
  isSettings?: boolean;
}

const ButtonChooser: FC<IButtonChooserProps> = ({
  leftTitle,
  rightTitle,
  centerTitle,
  defaultValue,
  isSettings = false,
  onChange,
}) => {
  const [activeTitle, setActiveTitle] = useState(defaultValue ?? leftTitle);

  const handleChange = useCallback(
    (title: string) => () => {
      setActiveTitle(title);
      onChange && onChange(title);
    },
    [onChange],
  );

  useEffect(() => {
    if (defaultValue) {
      setActiveTitle(defaultValue);
    }
  }, [defaultValue]);

  return (
    <Container $isSettings={isSettings}>
      <Toggle
        onClick={handleChange(leftTitle)}
        $isActive={activeTitle === leftTitle}
      >
        {leftTitle}
      </Toggle>

      <Toggle
        onClick={handleChange(centerTitle)}
        $isActive={activeTitle === centerTitle}
        $isCenter
      >
        {centerTitle}
      </Toggle>

      <Toggle
        onClick={handleChange(rightTitle)}
        $isActive={activeTitle === rightTitle}
      >
        {rightTitle}
      </Toggle>
    </Container>
  );
};

export default ButtonChooser;
